export class CustomOverlay {
    containerDiv = document.createElement('div');
    private latLng: google.maps.LatLng;
    private onContainerReady: (container: HTMLDivElement) => void;
    private overlay: google.maps.OverlayView;

    constructor(latLng: google.maps.LatLng, onContainerReady: (container: HTMLDivElement) => void) {
        this.latLng = latLng;
        this.onContainerReady = onContainerReady;
        this.containerDiv.style.position = 'absolute';

        const OverlayView = google.maps.OverlayView;

        class CustomOverlayView extends OverlayView {
            private parent: CustomOverlay;

            constructor(parent: CustomOverlay) {
                super();
                this.parent = parent;
            }

            onAdd() {
                this.parent.onAdd();
            }

            draw() {
                this.parent.draw(this);
            }

            onRemove() {
                this.parent.onRemove();
            }
        }

        this.overlay = new CustomOverlayView(this);
    }

    setMap(map: google.maps.Map | null) {
        this.overlay.setMap(map);
    }

    private onAdd() {
        const panes = this.overlay.getPanes();
        if (panes) {
            panes.overlayMouseTarget.appendChild(this.containerDiv);
            this.onContainerReady(this.containerDiv);
        }
    }

    private draw(overlay: google.maps.OverlayView) {
        const projection = overlay.getProjection();
        if (!projection) return;

        const point = projection.fromLatLngToDivPixel(this.latLng);
        if (point) {
            this.containerDiv.style.left = `${point.x}px`;
            this.containerDiv.style.top = `${point.y}px`;
            this.containerDiv.style.transform = 'translate(-50%, -50%)';
        }
    }

    private onRemove() {
        this.containerDiv?.parentElement?.removeChild(this.containerDiv);
    }
}
